import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import { BLACKOUT_SCOPES, SCOPE_TAG } from "helpers/blackouts"
import styles from "./index.module.css"

/** Scope -> an existing DSIcon whose glyph matches the design's tag icon. */
const SCOPE_ICON = {
  [BLACKOUT_SCOPES.BUSINESS]: "blackout",
  [BLACKOUT_SCOPES.LISTING]: "experiences",
  [BLACKOUT_SCOPES.CREW]: "users",
  [BLACKOUT_SCOPES.EQUIPMENT]: "box"
}

/**
 * The scope pill — Business / Listings / Crew / Equipment.
 *
 * `tone="soft"` is the pastel pill used on the settings rows; `tone="solid"` is the dark
 * pill the calendar day panel uses, where it sits on a white card next to the date.
 */
const BlackoutScopeTag = ({ scope, label, tone = "soft", showIcon = true, className = "" }) => {
  const { t } = useTranslation()
  const tag = SCOPE_TAG[scope]

  if (!tag) return null

  const isSolid = tone === "solid"

  return (
    <span className={`${styles.tag} ${isSolid ? styles.solid : styles[tag.variant]} ${className}`}>
      {showIcon && (
        <Icon
          type={isSolid ? "ds" : "feather"}
          name={isSolid ? SCOPE_ICON[scope] : "AlertTriangle"}
          width={isSolid ? 16 : 12}
          height={isSolid ? 16 : 12}
          color="currentColor"
        />
      )}
      {label || t(tag.labelKey, { defaultValue: tag.labelDefault })}
    </span>
  )
}

BlackoutScopeTag.propTypes = {
  scope: PropTypes.string.isRequired,
  /** Overrides the scope's default copy, e.g. "All Experiences Blackout". */
  label: PropTypes.string,
  tone: PropTypes.oneOf(["soft", "solid"]),
  showIcon: PropTypes.bool,
  className: PropTypes.string
}

export default BlackoutScopeTag
